import React, { Component } from 'react';
import {jsonUrl} from '../components/Factory'
import KalenderDetails from '../components/KalenderDetails'; 
import KalenderAnmelden from '../components/KalenderAnmelden'; 

class KalenderDetailsContainer extends Component {
  constructor(props) {
		super(props);
		this.state = { 
		  anmelden:'',
		  kalenderDate:''
		}
		this.handleOpen = this.handleOpen.bind(this);	
		this.handleClose = this.handleClose.bind(this);	
  }
  handleOpen(data){
		this.setState({
			anmelden:'open',
			kalenderName:data[0],
			kalenderDate:data[1],
			perform:data[2],
			type:data[3],
			kalenderTime:data[4]
		});
		document.body.classList.toggle('no-scroll');
  }
  handleClose(data){
		this.setState({
			anmelden:''
		});
		document.body.classList.toggle('no-scroll');
  }
  componentDidMount(){	 
	setTimeout(function(){
		document.getElementById('submenu-kalender').classList.add('active');
		document.getElementById('menu-programm').classList.add('active');
	},400);
  }
  componentWillUnmount(){
	document.getElementById('submenu-kalender').classList.remove('active');
	document.getElementById('menu-programm').classList.remove('active');	
  }
  componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}		
  render() {
		   const {page,kalenderPage,staticData} = this.props.resolves;
		   return (
                <div>
					<div className="container-fluid lg-side-padding content-section">
						<div className="row">
							<div className="col-md-12">
								<KalenderDetails staticData={staticData} handleClick={this.handleOpen} {...page}/>
							</div>
						</div>
					</div>
					<KalenderAnmelden staticData={staticData} eventdate={this.state.kalenderDate} kalender={page.title.rendered} {...kalenderPage} handleClick={this.handleClose} kalenderTime={this.state.kalenderTime} perform={this.state.perform} formType={this.state.type} status={this.state.anmelden} />
				</div>
            )
       
  }
}
export function getDetailsPage(name,type){
	return fetch(jsonUrl({ 
						number:1,
						type:type,
						slug:name
					}),	{
						credentials: 'include',
						headers: {
							'X-WP-Nonce':window.appInfo.nonce
						},
					})
				  .then(res => res.json())
				  .then(res => {
					document.title = res[0].yoast.title;
					window.lang_switch = res[0].lang_switch_url;
					return res[0];		 
				  })
}
export default KalenderDetailsContainer;


// WEBPACK FOOTER //
// ./src/containers/KalenderDetailsContainer.js